import { useCallback, useMemo, useState } from "react";

const INITIAL_STATE = {
  open: false,
  applicantIds: [],
};

const useEventPayrollAttachMarkPaid = ({ records, lang } = {}) => {
  const [state, setState] = useState(INITIAL_STATE);

  const close = useCallback(() => {
    setState(INITIAL_STATE);
  }, []);

  const open = useCallback((applicantIds) => {
    const normalizedIds = Array.from(
      new Set(
        (applicantIds || []).filter(
          (id) => id !== null && id !== undefined && id !== "",
        ),
      ),
    );

    if (!normalizedIds.length) return;

    setState({
      open: true,
      applicantIds: normalizedIds,
    });
  }, []);

  const workerName = useMemo(() => {
    if (state.applicantIds.length !== 1) return null;

    const record = (records || []).find((row) => row.id === state.applicantIds[0]);
    if (!record) return null;

    return lang === "ar" ? record.nameAr || record.name : record.name;
  }, [lang, records, state.applicantIds]);

  return {
    open: state.open,
    applicantIds: state.applicantIds,
    workerName,
    openAttachMarkPaid: open,
    close,
  };
};

export default useEventPayrollAttachMarkPaid;
